import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { startAnalytics, track } from './lib/analytics'
import { isDemo } from './lib/config'
import './styles.css'

startAnalytics()

// Demoen er toppen av trakta: den prøves uten konto, og etterlater seg derfor
// ingenting i databasen. Uten denne hendelsen finnes det ingen måte å vite
// hvor mange som prøvde appen før de bestemte seg.
if (isDemo) track('demo-apnet')

createApp(App).use(createPinia()).use(router).mount('#app')
